module.exports = __webpack_public_path__ + "static/media/mailchimp.2c9d2618.png";